"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const polkabtc_types_1 = __importDefault(require("@interlay/polkabtc-types"));
exports.default = {
    types: polkabtc_types_1.default.types[0].types,
    rpc: parseProviderRpcDefinitions(polkabtc_types_1.default.rpc),
    providerRpc: polkabtc_types_1.default.rpc,
};
function parseProviderRpcDefinitions(rpcDefs) {
    const parsedDefs = {};
    for (const module in rpcDefs) {
        const definitions = rpcDefs[module];
        for (const definitionName in definitions) {
            const definitionBody = definitions[definitionName];
            const decoratedDefinitionBody = Object.assign(Object.assign({}, definitionBody), { aliasSection: module });
            parsedDefs[definitionName] = decoratedDefinitionBody;
        }
    }
    return parsedDefs;
}
//# sourceMappingURL=definitions.js.map